import {
  ActivatedRouteSnapshot,
  ResolveFn,
  RouterStateSnapshot,
} from '@angular/router';

export const RedirectExternalResolver: ResolveFn<{ url: string }> = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
): { url: string } => {
  const externalUrl = route.paramMap.get('url');

  return { url: externalUrl || '' };
};
